import { energyAnalysisApiSlice as api } from '../../../apiSlice';
export const addTagTypes = ['CO2e Data'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      co2ETimestampsSummaryCo2EEmissionTimestampsSummaryAccountIdEnergyGroupIdGet:
        build.query<
          Co2ETimestampsSummaryCo2EEmissionTimestampsSummaryAccountIdEnergyGroupIdGetApiResponse,
          Co2ETimestampsSummaryCo2EEmissionTimestampsSummaryAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/co2e_emission_timestamps_summary/${queryArg.accountId}/${queryArg.energyGroupId}`,
          }),
          providesTags: ['CO2e Data'],
        }),
      co2EOverviewCo2EEmissionDataAccountIdEnergyGroupIdGet: build.query<
        Co2EOverviewCo2EEmissionDataAccountIdEnergyGroupIdGetApiResponse,
        Co2EOverviewCo2EEmissionDataAccountIdEnergyGroupIdGetApiArg
      >({
        query: (queryArg) => ({
          url: `/co2e_emission_data/${queryArg.accountId}/${queryArg.energyGroupId}`,
          params: {
            start_timestamp: queryArg.startTimestamp,
            end_timestamp: queryArg.endTimestamp,
          },
        }),
        providesTags: ['CO2e Data'],
      }),
      co2EPerNodeEmissionsCo2EEmissionDataPerNodeAccountIdEnergyGroupIdGet:
        build.query<
          Co2EPerNodeEmissionsCo2EEmissionDataPerNodeAccountIdEnergyGroupIdGetApiResponse,
          Co2EPerNodeEmissionsCo2EEmissionDataPerNodeAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/co2e_emission_data_per_node/${queryArg.accountId}/${queryArg.energyGroupId}`,
            params: {
              start_timestamp: queryArg.startTimestamp,
              end_timestamp: queryArg.endTimestamp,
            },
          }),
          providesTags: ['CO2e Data'],
        }),
      co2ETimestampsSummaryHeatWaterCo2EEmissionTimestampsSummaryHeatWaterAccountIdEnergyGroupIdGet:
        build.query<
          Co2ETimestampsSummaryHeatWaterCo2EEmissionTimestampsSummaryHeatWaterAccountIdEnergyGroupIdGetApiResponse,
          Co2ETimestampsSummaryHeatWaterCo2EEmissionTimestampsSummaryHeatWaterAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/co2e_emission_timestamps_summary_heat_water/${queryArg.accountId}/${queryArg.energyGroupId}`,
          }),
          providesTags: ['CO2e Data'],
        }),
      co2EOverviewHeatWaterCo2EEmissionDataHeatWaterAccountIdEnergyGroupIdGet:
        build.query<
          Co2EOverviewHeatWaterCo2EEmissionDataHeatWaterAccountIdEnergyGroupIdGetApiResponse,
          Co2EOverviewHeatWaterCo2EEmissionDataHeatWaterAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/co2e_emission_data_heat_water/${queryArg.accountId}/${queryArg.energyGroupId}`,
            params: {
              start_timestamp: queryArg.startTimestamp,
              end_timestamp: queryArg.endTimestamp,
            },
          }),
          providesTags: ['CO2e Data'],
        }),
      co2EPerNodeHeatWaterCo2EEmissionDataPerNodeHeatWaterAccountIdEnergyGroupIdGet:
        build.query<
          Co2EPerNodeHeatWaterCo2EEmissionDataPerNodeHeatWaterAccountIdEnergyGroupIdGetApiResponse,
          Co2EPerNodeHeatWaterCo2EEmissionDataPerNodeHeatWaterAccountIdEnergyGroupIdGetApiArg
        >({
          query: (queryArg) => ({
            url: `/co2e_emission_data_per_node_heat_water/${queryArg.accountId}/${queryArg.energyGroupId}`,
            params: {
              start_timestamp: queryArg.startTimestamp,
              end_timestamp: queryArg.endTimestamp,
            },
          }),
          providesTags: ['CO2e Data'],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as energyAnalysisOpenApi };
export type Co2ETimestampsSummaryCo2EEmissionTimestampsSummaryAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ TimestampsSummaryModel;
export type Co2ETimestampsSummaryCo2EEmissionTimestampsSummaryAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get the co2e emission overview for. */
    energyGroupId: number;
    /** The account id to get the co2e emission overview for. */
    accountId: number;
  };
export type Co2EOverviewCo2EEmissionDataAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ Co2EOverviewOutput;
export type Co2EOverviewCo2EEmissionDataAccountIdEnergyGroupIdGetApiArg = {
  /** The energy group id to get the co2e emission overview for. */
  energyGroupId: number;
  /** The account id to get the co2e emission overview for. */
  accountId: number;
  /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  startTimestamp: string;
  /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
  endTimestamp: string;
};
export type Co2EPerNodeEmissionsCo2EEmissionDataPerNodeAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ NodeCo2EEmissionsModel;
export type Co2EPerNodeEmissionsCo2EEmissionDataPerNodeAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get the per-node CO2e emissions for. */
    energyGroupId: number;
    /** The account id to get the per-node CO2e emissions for. */
    accountId: number;
    /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    startTimestamp: string;
    /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    endTimestamp: string;
  };
export type Co2ETimestampsSummaryHeatWaterCo2EEmissionTimestampsSummaryHeatWaterAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ TimestampsSummaryModel;
export type Co2ETimestampsSummaryHeatWaterCo2EEmissionTimestampsSummaryHeatWaterAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get the CO2e emission timestamps summary for. */
    energyGroupId: number;
    /** The account id to get the CO2e emission timestamps summary for. */
    accountId: number;
  };
export type Co2EOverviewHeatWaterCo2EEmissionDataHeatWaterAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ HeatWaterCo2EOverviewOutput;
export type Co2EOverviewHeatWaterCo2EEmissionDataHeatWaterAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get the co2e emission data for. */
    energyGroupId: number;
    /** The account id to get the co2e emission data for. */
    accountId: number;
    /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    startTimestamp: string;
    /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    endTimestamp: string;
  };
export type Co2EPerNodeHeatWaterCo2EEmissionDataPerNodeHeatWaterAccountIdEnergyGroupIdGetApiResponse =
  /** status 200 Successful Response */ HeatWaterNodeCo2EEmissionsModel;
export type Co2EPerNodeHeatWaterCo2EEmissionDataPerNodeHeatWaterAccountIdEnergyGroupIdGetApiArg =
  {
    /** The energy group id to get the per-node CO2e emission data for. */
    energyGroupId: number;
    /** The account id to get the per-node CO2e emission data for. */
    accountId: number;
    /** Start of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    startTimestamp: string;
    /** End of the data extraction period. Format: YYYY-MM-DDTHH:MM:SS+00:00 */
    endTimestamp: string;
  };
export type TimestampsSummaryModel = {
  /** The minimum earliest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  minEarliestDataTimestamp: string | null;
  /** The maximum earliest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  maxEarliestDataTimestamp: string | null;
  /** The minimum latest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  minLatestDataTimestamp: string | null;
  /** The maximum latest timestamp of the data across all nodes. Format: YYYY-MM-DDTHH:MM:SSZ */
  maxLatestDataTimestamp: string | null;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type EnergyDataSummaryModel = {
  /** The total energy usage in kWh. */
  TotalEnergyUsage: number;
  /** The average energy usage in kWh. */
  AverageEnergyUsage: number;
  /** The max energy usage in kWh. */
  MaxEnergyUsage: number;
  /** The min energy usage in kWh. */
  MinEnergyUsage: number;
  /** The total measured energy in kWh. Only available if the energy data is measured data. */
  TotalMeasuredEnergy?: number | null;
  /** The percentage of measured energy compared to the total energy usage. Only available if the energy data is measured data. */
  MeasuredEnergyPercentage?: number | null;
  /** The start timestamp of the energy data. Format: YYYY-MM-DDTHH:MM:SSZ */
  StartTimestamp: string;
  /** The end timestamp of the energy data. Format: YYYY-MM-DDTHH:MM:SSZ */
  EndTimestamp: string;
  /** The base unit for the energy data. */
  BaseUnit?: string;
};
export type Co2EDataPoint = {
  /** The timestamp of the data point. Format: YYYY-MM-DDTHH:MM:SSZ */
  timestamp: string;
  /** The CO2e emissions in g. */
  CO2e: number;
  /** The CO2e emissions per kWh in g. */
  CO2ePerkWh: number;
};
export type Co2EEmissionsSummaryModel = {
  /** The total CO2e emissions in g. */
  CO2eEmissions?: number | null;
  /** The CO2e emissions from distribution losses in g. */
  DistributionLossEmissions?: number | null;
  /** The CO2e emissions from transmission losses in g. */
  TransmissionLossEmissions?: number | null;
  /** The CO2e emissions from energy consumption in g. */
  EnergyConsumptionEmissions?: number | null;
  /** The CO2e emissions per kWh in g based on a weighted average using power consumption data. */
  CO2eEmissionsPerKWh?: number | null;
  /** Non-weighted average CO2e emissions per kWh in g based on the CO2e declarations. */
  CO2eEmissionsPerKWhReference?: number | null;
  /** The standard deviation of the CO2e emissions per kWh in g based on the CO2e declarations. */
  CO2eEmissionsPerKWhReferenceSTD?: number | null;
  /** The position of the CO2e emissions per kWh in a Gaussian cumulative distribution function. */
  CO2eEmissionsPerKWhReferenceCDF?: number | null;
  /** The energy usage in kWh. */
  EnergyUsage?: number | null;
  /** The energy usage in kWh that is eligible for CO2e emissions calculation. */
  EnergyUsageEligible?: number | null;
  /** The energy usage in kWh that is eligible for CO2e emissions calculation after correcting for the distribution and transmission losses. */
  EnergyUsageCorrected?: number | null;
  /** The distribution loss percentage. */
  DistributionLossPercentage?: number | null;
  /** The transmission loss percentage. */
  TransmissionLossPercentage?: number | null;
  /** The base unit for the CO2e emissions. */
  BaseUnitCO2e?: string;
  /** The base unit for the energy data. */
  BaseUnitEnergy?: string;
};
export type GridMixSummaryModel = {
  /** The name of the reporting group producing the electricity to the grid. */
  Name: string;
  /** The contribution percentage of the reporting group producing the electricity to the grid. */
  ContributionPercentage: number;
};
export type ReShareSummaryModel = {
  /** The renewable energy share in percentage. */
  REShare: number | null;
  /** The renewable energy share in percentage including nuclear. */
  REShareWithNuclear: number | null;
};
export type MonthlyCo2EDataPoint = {
  /** The year of the data point. */
  year: number;
  /** The month of the data point. */
  month: number;
  /** The CO2e emissions in grams. */
  CO2e: number | null;
  /** The CO2e emissions per kWh in grams. */
  CO2ePerkWh: number | null;
  /** The CO2e emissions from energy consumption in grams. */
  CO2eEnergy: number | null;
  /** The CO2e emissions from distribution losses in grams. */
  CO2eDistribution: number | null;
  /** The CO2e emissions from transmission losses in grams. */
  CO2eTransmission: number | null;
  /** The energy consumption in kWh. */
  Energy: number | null;
  /** The energy consumption eligible for CO2e emissions in kWh. */
  EnergyEligible: number | null;
  /** The CO2e emissions from the same period last year in grams. */
  CO2eLastYear: number | null;
  /** The CO2e emissions per kWh from the same period last year in grams. */
  CO2ePerkWhLastYear: number | null;
  /** The energy consumption from the same period last year in kWh. */
  EnergyLastYear: number | null;
  /** The energy consumption eligible for CO2e emissions from the same period last year in kWh. */
  EnergyEligibleLastYear: number | null;
  /** The timestamp of the data point in ISO 8601 format. */
  timestamp: string;
};
export type MonthlyCo2EEmissionsModel = {
  /** The name of the entity. (Could be SEU or node name) */
  Name: string;
  /** The ID of the node. None if its SEU based. */
  Id?: string | null;
  /** The monthly CO2e emissions data. */
  Data: MonthlyCo2EDataPoint[];
};
export type Co2EEmissionData = {
  /** The CO2e emissions data as a time series. */
  CO2eData: Co2EDataPoint[];
  /** The grid mix distribution data as a time series. */
  GridMixDistributionData: object[] | null;
  /** The CO2e emissions summary. */
  CO2eEmissionsSummary: Co2EEmissionsSummaryModel;
  /** The grid mix summary. */
  GridMixSummary: GridMixSummaryModel[] | null;
  /** The renewable energy share summary. */
  REShareSummary: ReShareSummaryModel;
  /** The CO2e emissions data as a monthly time series. */
  MonthlyCO2eEmissions?: MonthlyCo2EEmissionsModel[];
};
export type ApiWarning = {
  /** The warning message */
  message: string;
  /** The warning type */
  warning_type: string;
  /** The warning details */
  details?: object;
};
export type Co2EOverviewOutput = {
  /** The energy data summary. */
  EnergyDataSummary: EnergyDataSummaryModel;
  /** The CO2e emissions data for the location based CO2e emission. */
  Location: Co2EEmissionData;
  /** The CO2e emissions data for the municipality based CO2e emission. */
  Municipality: Co2EEmissionData;
  /** The CO2e emissions data for the market based CO2e emission. */
  Market: Co2EEmissionData;
  /** Gives information about in what ranges the data is present. */
  TimestampsSummary: TimestampsSummaryModel;
  Warnings?: ApiWarning[];
};
export type NodeCo2EEmissionsModel = {
  /** CO2e emission Per Node for location based emissions. */
  Location: MonthlyCo2EEmissionsModel[];
  /** CO2e emission Per Node for municipality based emissions. */
  Municipality: MonthlyCo2EEmissionsModel[];
  /** CO2e emission Per Node for market based emissions. */
  Market: MonthlyCo2EEmissionsModel[];
  /** Gives information about in what ranges the data is present. */
  TimestampsSummary: TimestampsSummaryModel;
  Warnings?: ApiWarning[];
};
export type HeatWaterCo2EEmissionsSummaryModel = {
  /** Total CO2e emissions in kg. */
  CO2eEmissions?: number | null;
  /** Weighted average CO2e emissions per unit (kg CO2e per kWh or m³). */
  CO2eEmissionsPerUnit?: number | null;
  /** Weighted average CO2e coefficient used in calculations. */
  AverageCO2eCoefficient?: number | null;
  /** Total energy/water consumption. */
  EnergyUsage?: number | null;
  /** Consumption with CO2e coefficient coverage. */
  EnergyUsageEligible?: number | null;
  /** Base unit for CO2e emissions. */
  BaseUnitCO2e?: string;
  /** Base unit for energy (kWh for heat, m³ for water). */
  BaseUnitEnergy: string;
};
export type HeatWaterCo2EDataPoint = {
  /** Timestamp in ISO 8601 format. */
  timestamp: string;
  /** Energy consumption (kWh for heat, m³ for water). */
  value: number;
  /** CO2e coefficient used (kg CO2e per kWh or m³). */
  co2e_coefficient: number;
  /** Calculated CO2e emission in kg (value * co2e_coefficient). */
  co2e_emission: number;
};
export type HeatWaterMonthlyCo2EDataPoint = {
  /** Year of the data point. */
  year: number;
  /** Month of the data point (1-12). */
  month: number;
  /** Total CO2e emissions for the month in kg. */
  CO2e?: number | null;
  /** Average CO2e per unit for the month (kg per kWh or m³). */
  CO2ePerUnit?: number | null;
  /** Weighted average CO2e coefficient for the month. */
  AverageCO2eCoefficient?: number | null;
  /** Total energy/water consumption for the month. */
  Energy?: number | null;
  /** Consumption with CO2e coefficient coverage for the month. */
  EnergyEligible?: number | null;
  /** CO2e emissions from the same month last year in kg. */
  CO2eLastYear?: number | null;
  /** CO2e per unit from the same month last year. */
  CO2ePerUnitLastYear?: number | null;
  /** Energy/water consumption from the same month last year. */
  EnergyLastYear?: number | null;
  /** Eligible consumption from the same month last year. */
  EnergyEligibleLastYear?: number | null;
  /** First day of the month in ISO 8601 format. */
  timestamp: string;
};
export type HeatWaterMonthlyCo2EEmissionsModel = {
  /** Name of the entity (SEU type or matrikel node name). */
  Name: string;
  /** Node ID (matrikel_node_id for per-node, None for SEU). */
  Id?: string | null;
  /** Utility provider ID for coefficient traceability (per-node only). */
  UtilityProviderId?: string | null;
  /** Monthly CO2e emissions data points. */
  Data: HeatWaterMonthlyCo2EDataPoint[];
};
export type MeterCoverageSummaryModel = {
  /** Number of meter nodes with CO2e data. */
  nodeCount: number;
  /** Number of unique matrikels (buildings) with CO2e data. */
  matrikelCount: number;
  /** List of SEU types found in the CO2e data. */
  seuTypes: string[];
  /** Number of meters with CO2e coefficient coverage. */
  metersWithCoverage: number;
  /** Number of meters excluded from CO2e calculation due to missing coefficients. */
  metersWithoutCoverage: number;
};
export type HeatWaterCo2EOverviewOutput = {
  /** Energy tree type (PortfolioHeat or PortfolioWater). */
  EnergyTreeType: string;
  /** Summary of energy/water consumption data. */
  EnergyDataSummary: EnergyDataSummaryModel;
  /** Summary of CO2e emissions for the queried period. */
  CO2eEmissionsSummary: HeatWaterCo2EEmissionsSummaryModel;
  /** Hourly CO2e data points. */
  CO2eData: HeatWaterCo2EDataPoint[];
  /** Monthly aggregated CO2e emissions by SEU type. */
  MonthlyCO2eEmissions: HeatWaterMonthlyCo2EEmissionsModel[];
  /** Standard timestamp range information. */
  TimestampsSummary: TimestampsSummaryModel;
  /** Heat/Water specific meter coverage information. */
  MeterCoverageSummary: MeterCoverageSummaryModel;
  /** Warnings generated during processing. */
  Warnings?: ApiWarning[];
};
export type HeatWaterNodeCo2EEmissionsModel = {
  /** Energy tree type (PortfolioHeat or PortfolioWater). */
  EnergyTreeType: string;
  /** CO2e emissions per matrikel/building (grouped by matrikel_node_id). */
  Nodes: HeatWaterMonthlyCo2EEmissionsModel[];
  /** Standard timestamp range information. */
  TimestampsSummary: TimestampsSummaryModel;
  /** Heat/Water specific meter coverage information. */
  MeterCoverageSummary: MeterCoverageSummaryModel;
  /** Warnings generated during processing. */
  Warnings?: ApiWarning[];
};
export const {
  useCo2ETimestampsSummaryCo2EEmissionTimestampsSummaryAccountIdEnergyGroupIdGetQuery,
  useCo2EOverviewCo2EEmissionDataAccountIdEnergyGroupIdGetQuery,
  useCo2EPerNodeEmissionsCo2EEmissionDataPerNodeAccountIdEnergyGroupIdGetQuery,
  useCo2ETimestampsSummaryHeatWaterCo2EEmissionTimestampsSummaryHeatWaterAccountIdEnergyGroupIdGetQuery,
  useCo2EOverviewHeatWaterCo2EEmissionDataHeatWaterAccountIdEnergyGroupIdGetQuery,
  useCo2EPerNodeHeatWaterCo2EEmissionDataPerNodeHeatWaterAccountIdEnergyGroupIdGetQuery,
} = injectedRtkApi;
